import { defineComponent, h } from 'vue'
import AssistantModuleIcon, {
  type ModuleIconKind,
  moduleIconKinds,
} from '@/components/shared/AssistantModuleIcon.vue'

const createAssistantIcon = (kind: ModuleIconKind) => defineComponent({
  name: `${kind[0].toUpperCase()}${kind.slice(1)}AssistantIcon`,
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    tile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { attrs }) {
    return () => h(AssistantModuleIcon, {
      ...attrs,
      kind,
      size: props.size,
      tile: props.tile,
    })
  },
})

export const GoalAssistantIcon = createAssistantIcon('goals')
export const ProjectAssistantIcon = createAssistantIcon('projects')
export const RequirementAssistantIcon = createAssistantIcon('requirements')
export const ProductAssistantIcon = createAssistantIcon('products')
export const IncidentAssistantIcon = createAssistantIcon('incidents')
export const FeedbackAssistantIcon = createAssistantIcon('feedback')
export const EfficiencyAssistantIcon = createAssistantIcon('efficiency')
export const VirtualEmployeeAssistantIcon = createAssistantIcon('virtualEmployee')
export const CollectAssistantIcon = createAssistantIcon('collect')

export const moduleIcons = {
  goals: GoalAssistantIcon,
  projects: ProjectAssistantIcon,
  requirements: RequirementAssistantIcon,
  products: ProductAssistantIcon,
  incidents: IncidentAssistantIcon,
  feedback: FeedbackAssistantIcon,
  efficiency: EfficiencyAssistantIcon,
  virtualEmployee: VirtualEmployeeAssistantIcon,
  collect: CollectAssistantIcon,
} as const

export { moduleIconKinds }
export type { ModuleIconKind }
